import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import get from 'lodash/get'
import { authSelector, companySelector } from './../../../selectors'
import { companyAction, authAction } from './../../../actions/'
import CustomTable from '../../../components/table'
import { getListUser } from '../../../selectors/employee/employee-selector'
import { employeeAction } from '../../../actions/employee'

const header = ['Start Date', 'Company ID', 'Company Name', 'Modified By']

class ListCompany extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      defaultCompanys: [],
      companys: [],
    }
    this.handleClickEdit = this.handleClickEdit.bind(this)
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.listCompany(access_token)
    this.props.getEmployeeList(access_token)
  }

  componentWillReceiveProps(nextProps) {
    if (get(nextProps, 'listCompanyData')) {
      this.setState({
        companys: get(nextProps, 'listCompanyData'),
        defaultCompanys: get(nextProps, 'listCompanyData'),
      })
    }
  }

  handleClickEdit(id) {
    this.props.handleClickEdit(true, id)
    this.props.handleSpan(true)
  }

  render() {
    const IsAdminUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')

    if (IsHRConfidentialUser !== undefined &&
      IsSystemUser !== undefined &&
      IsAdminUser !== undefined &&
      IsManagementUser !== undefined &&
      !(IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser)) window.location = '/home'

    return (
      /* eslint no-underscore-dangle: 0 */
      <CustomTable
        header={ header }
        data={ this.props.companys }
        handleClickEdit={ this.handleClickEdit }
        span={ get(this.props, 'span') }
        table={ this.props.table }
        employeeList={ this.props.employeeList }
      />
    )
  }
}

ListCompany.propTypes = {
  handleClickEdit: PropTypes.func.isRequired,
  handleSpan: PropTypes.array.isRequired,
  listCompany: PropTypes.func.isRequired,
  getEmployeeList: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  listCompanyData: companySelector.getListCompany,
  companyDeactivate: companySelector.getDeactivateCompanyData,
  employeeList: getListUser,
  authData: authSelector.getAuth,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  listCompany: companyAction.getCompany,
  deactivateCompany: companyAction.deactivateCompany,
  resetDeactivateCompany: companyAction.resetDeactivateCompany,
  resetListCompany: companyAction.resetListCompany,
  getEmployeeList: employeeAction.getUser,
  getAuth: authAction.auth,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ListCompany)



// WEBPACK FOOTER //
// ./src/pages/company/list/index.js